// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1hkp9","selects":"Documents_selects__2WK9m"};